/**
 * How much of the viewport's height a reader can see at once.
 *
 * In a parent with no fixed height the viewport grows to its pages, so its own
 * height is the content's; the window is then the limit on what fits on screen.
 */
export function visibleHeight(viewport: HTMLElement): number {
  return Math.min(viewport.clientHeight, window.innerHeight);
}
